{
  "title": "Ashardalon's Stride",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "3rd-level Transmutation",
  "level": 3,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V,S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "The billowing flames of a dragon blast from your feet, granting you explosive speed. For the duration, your speed increases by 20 feet and moving doesn’t provoke opportunity attacks.",
    "When you move within 5 feet of a creature or an object that isn’t being worn or carried, it takes 1d6 fire damage from your trail of heat. A creature or object can take this damage only once during a turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, increase your speed by 5 feet for each spell slot level above 3rd. The spell deals an additional 1d6 fire damage for each slot level above 3rd."
  ],
  "spellLists": ["artificer", "ranger", "sorcerer", "wizard"]
}
